import { useTextDomainContext } from "@/app/providers";
import React, { useContext, useEffect, useState } from "react";
import { BlackButton, Dropzone2, ModalBox, OutlinedButton } from "@/components";
import { Box } from "@mui/system";
import { bool, func } from "prop-types";
import { Container, Grid } from "@mui/material";
import { PartnerImagePath } from "@/hooks";
import { getPartnerKey } from "@/utils";
import { isEqual } from "lodash";

type UploadFileItem = {
  name?: string;
  path?: string;
  type?: string;
  size?: number;
};

type MultipleFilesUploadModalProps = {
  open: boolean;
  handleClose: () => void;
};

export const MultipleFilesUploadModal = (
  props: MultipleFilesUploadModalProps,
) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  // const partnerName = getPartnerName();
  const partnerKey = getPartnerKey();
  // const items = UploadModalCarouselItems();

  const [loginImage1, setLoginImage1] = useState<string | undefined>();
  const [selectedFiles, setSelectedFiles] = useState<UploadFileItem[]>([]);
  const [progress, setProgress] = useState<number[]>([]);
  const [startDummy, setStartDummy] = useState(false);
  const [loop, setLoop] = useState(false);

  useEffect(() => {
    const progressArray = progress;
    selectedFiles.forEach((file, index) => {
      if (!progressArray[index]) {
        progressArray[index] = 0;
      }
    });

    if (!isEqual(progress, progressArray)) {
      setProgress(progressArray);
    }
  }, [progress, selectedFiles]);

  useEffect(() => {
    if (startDummy) {
      let thisChanged = false;
      const selectedProgressId = Math.floor(Math.random() * progress.length);
      if (
        progress[selectedProgressId] > -1 &&
        progress[selectedProgressId] < 101
      ) {
        thisChanged = true;
        const newProgress = progress;
        newProgress[selectedProgressId]++;
        if (newProgress[selectedProgressId] > 100) {
          newProgress[selectedProgressId] = 100;
        }
        setProgress(newProgress);
      }

      let allDummyDone = true;
      progress.forEach((obj) => {
        if (obj < 100) {
          allDummyDone = false;
        }
      });

      if (allDummyDone) {
        setStartDummy(false);
      } else if (!thisChanged) {
        setLoop(!loop);
      } else {
        setLoop(!loop);
      }
    }
  }, [loop, progress, startDummy]);

  PartnerImagePath(partnerKey, "login/login-1.png").then((imageUrl) => {
    setLoginImage1(imageUrl);
  });

  const uploadClickHandler = () => {
    setStartDummy(true);
  };

  const handleGetSelected = (files: UploadFileItem[]) => {
    setSelectedFiles(files);
  };

  return (
    <ModalBox
      open={props.open}
      handleClose={props.handleClose}
      crossColor="common.white"
      sx={{
        maxWidth: 1000,
        maxHeight: 600,
        width: "80vw",
        height: "80vh",
      }}
    >
      <Box
        sx={{
          height: "100%",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
          }}
        >
          <Grid
            size={{ xs: 12, md: 5 }}
            sx={{
              height: "100%",
            }}
          >
            <Box
              sx={{
                height: "100%",
              }}
            >
              <Container
                sx={{
                  textAlign: "center",
                  height: "calc(100% - 70px)",
                  p: 2,
                }}
              >
                <Dropzone2
                  getSelected={handleGetSelected}
                  progress={progress}
                />
              </Container>

              <Container
                sx={{
                  textAlign: "center",
                  height: "70px",
                  p: 2,
                }}
              >
                <Grid container spacing={3}>
                  <Grid size={{ xs: 6 }}>
                    <OutlinedButton fullWidth onClick={props.handleClose}>
                      {gettext("Cancel")}
                    </OutlinedButton>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <BlackButton fullWidth onClick={uploadClickHandler}>
                      {gettext("Upload")}
                    </BlackButton>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, md: 7 }}
            sx={{
              backgroundImage: 'url("' + loginImage1 + '")',
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              display: {
                xs: "none",
                md: "block",
              },
            }}
          >
            <Grid
              size={{ xs: 12 }}
              sx={{
                backgroundColor: "secondary.700",
                opacity: "0.5",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                pointerEvents: "none",
              }}
            ></Grid>
            {/*<Carousel indicatorContainerProps={{*/}
            {/*  style: {*/}
            {/*    marginLeft: "25px",*/}
            {/*    textAlign: "left",*/}
            {/*  }*/}

            {/*}} sx={{*/}
            {/*  opacity: "1",*/}
            {/*  height: "100%",*/}
            {/*}}>*/}
            {/*  {*/}
            {/*    items.map((item, i) => <UploadModalCarousel key={i} item={item}/>)*/}
            {/*  }*/}
            {/*</Carousel>*/}
          </Grid>
        </Grid>
      </Box>
    </ModalBox>
  );
};

MultipleFilesUploadModal.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
};
